import { LoginApiFactory, ResetPasswordApiFactory, AccountApiFactory } from "./typescript_api_client";
import config from "./config";

export const { login, sSOLogin } = LoginApiFactory(config, config.basePath);
export const { startResetPassword, submitNewPassword } = ResetPasswordApiFactory(config, config.basePath);
export const { confirmAccount } = AccountApiFactory(config, config.basePath);
export const { validateToken } = AccountApiFactory(config, config.basePath);
